import { HHTooltip } from '@hinge-health/react-component-library';
import InfoIcon from '@mui/icons-material/Info';

export const BillAmountMismatchIcon = (): JSX.Element => (
  <HHTooltip
    title={
      'Bill amount does not match expected amount. See price adjustment for more info.'
    }
    hhVariant="bottom"
  >
    <InfoIcon color="error" fontSize="small" />
  </HHTooltip>
);
